import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error with full details in development
    console.error('ErrorBoundary caught an error:', error);
    console.error('Error Info:', errorInfo);

    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // In development, also show the full error in an alert
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        alert(`Development Error:\n\n${error.message}\n\nStack:\n${error.stack}\n\nComponent Stack:\n${errorInfo.componentStack}`);
      }, 100);
    }
  }

  render() {
    if (this.state.hasError) {
      const { error, errorInfo } = this.state;

      return (
        <div style={{
          padding: '20px',
          backgroundColor: '#ffebee',
          border: '1px solid #f44336',
          borderRadius: '4px',
          margin: '20px',
          fontFamily: 'monospace'
        }}>
          <h2 style={{ color: '#d32f2f', marginTop: 0 }}>Something went wrong</h2>

          {process.env.NODE_ENV === 'development' && error && (
            <div>
              <h3>Error Details:</h3>
              <p><strong>Message:</strong> {error.message}</p>

              <h4>Stack Trace:</h4>
              <pre style={{
                backgroundColor: '#f5f5f5',
                padding: '10px',
                overflow: 'auto',
                fontSize: '12px',
                whiteSpace: 'pre-wrap'
              }}>
                {error.stack}
              </pre>

              {errorInfo && (
                <>
                  <h4>Component Stack:</h4>
                  <pre style={{
                    backgroundColor: '#f5f5f5',
                    padding: '10px',
                    overflow: 'auto',
                    fontSize: '12px',
                    whiteSpace: 'pre-wrap'
                  }}>
                    {errorInfo.componentStack}
                  </pre>
                </>
              )}
            </div>
          )}

          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '10px',
              padding: '8px 16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;